import React, { Dispatch, SetStateAction } from 'react';
import { InfoModalType } from '../Profiles.controller';
import {
  GetSocialProfiles_workspace_socialProfiles,
  GetSocialProfiles_workspace_socialProfiles_FacebookSocialProfile
} from '../../../../models/legacy-graphql';
import { BoxNotification } from '../../../../components/containers/BoxNotification';
import { Modal } from '../../../../components/containers/Modal';

export type InfoModalObject = {
  type: InfoModalType;
  profiles: GetSocialProfiles_workspace_socialProfiles[];
};

export type GroupAddedModalViewProps = {
  //
  infoModal: InfoModalObject;
  onClose: VoidFunction;
  setInfoModal: Dispatch<SetStateAction<InfoModalObject | null>>;
};

export const InfoModalView = (props: GroupAddedModalViewProps): JSX.Element => {
  let infoModalContent: JSX.Element = <></>;
  let infoModalTitle: string;
  let infoModalButtonLabel: string;
  switch (props.infoModal.type) {
    case 'GroupAdded':
      infoModalTitle = 'Action Required';
      infoModalContent = (
        <>
          <p>Facebook requires you to add our app to each Group that you want to post to.</p>
          <p>
            <strong>Here’s what you need to do:</strong>
          </p>
          <ol>
            <li>
              Go to{' '}
              <ul>
                {props.infoModal.profiles.map((profile, index) => {
                  const fbprofile = profile as GetSocialProfiles_workspace_socialProfiles_FacebookSocialProfile;
                  return (
                    <li key={`group_${index}`}>
                      <a
                        href={`https://www.facebook.com/groups/${fbprofile.facebookId}/edit`}
                        target={'_blank'}
                        rel={'noreferrer'}>
                        {fbprofile.displayName}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
            <li>
              Under “Apps” section, click the pencil icon and click <strong>Add Apps</strong>.
            </li>
            <li>
              Type “SmarterQueue” in the searchbox, then click on the SmarterQueue app icon that appears and click{' '}
              <strong>Add</strong>.
            </li>
          </ol>
          <div className={'margin-top-small-16'}>
            <BoxNotification type={'info'}>
              You will need to repeat these steps for each Group you connect to SmarterQueue.
            </BoxNotification>
          </div>
        </>
      );
      infoModalButtonLabel = 'Done';
      break;
  }
  return (
    <Modal
      onClose={() => {
        props.setInfoModal(null);
        props.onClose();
      }}
      primaryButtonTitle={infoModalButtonLabel}
      primaryButtonAction={() => {
        props.setInfoModal(null);
        props.onClose();
      }}
      title={infoModalTitle}
      closeOnClickOutside={false}
      showCloseIcon>
      {infoModalContent}
    </Modal>
  );
};
